class Countdown {

  constructor() {
    this._elements = [];
    this._intervalId = null;
    const countdowns = document.querySelectorAll('[data-countdown]');
    countdowns.forEach(countdown => {
      this.addElement(countdown);
    });
    this.update();
  }

  _padZero(value) {
    return value < 10 ? '0' + value : value.toString();
  }

  /**
   * Add countdown element.
   *
   * @param {HTMLElement} el Element to add.
   */
  addElement(el) {
    this._elements.push(el);
    if (!this._intervalId) {
      this._intervalId = setInterval(this.update.bind(this), 1000);
    }
  }

  /**
   * Remove countdown element.
   *
   * @param {HTMLElement} el Element to remove.
   */
  removeElement(el) {
    const index = this._elements.findIndex(el);
    if (index > -1) {
      this._elements.splice(index, 1);
      if (this._elements.length === 0 && this._intervalId) {
        clearInterval(this._intervalId);
        this._intervalId = null;
      }
    }
  }

  /**
   * Update countdown element.
   *
   * @param {HTMLElement} el Element to update.
   */
  updateElement(el) {
    const parsedTime = Date.parse(el.getAttribute('data-countdown'));
    const startTime = parsedTime ? new Date(parsedTime) : false;
    if (!startTime) {
      return;
    }
    const dateParts = this.getTimeDifference(startTime, new Date());
    if (dateParts) {
      // Update visible time
      for (let key in dateParts) {
        const valueElement = el.querySelector(`[data-countdown-value="${key}"]`);
        const value = this._padZero(dateParts[key]);
        if (valueElement && value !== valueElement.innerHTML) {
          valueElement.innerHTML = value;
        }
      }

      // Update screenreader text
      const screenReaderEl = el.querySelector('[data-countdown-sr-time]');
      const screenReaderText = (screenReaderEl.getAttribute('data-countdown-sr-time') || '')
        .replace('%days%', dateParts.days)
        .replace('%hours%', dateParts.hours)
        .replace('%minutes%', dateParts.minutes)
        .replace('%seconds%', dateParts.seconds);
      screenReaderEl.innerText = screenReaderText || screenReaderEl.innerText;
    }
  }

  /**
   * Get time difference between two dates as days, hours, minutes and seconds.
   *
   * @param {Date} startTime Start time.
   * @param {Date} endTime End time.
   * @return {Object} Object containing days, hours, minutes and seconds.
   */
  getTimeDifference(startTime, endTime) {
    const secondsLeft = (startTime.getTime() - endTime.getTime()) / 1000;
    if (secondsLeft <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    const days = Math.floor(secondsLeft / (24 * 60 * 60));
    const hours = Math.floor((secondsLeft / (60 * 60)) - (days * 24));
    const minutes = Math.floor((secondsLeft / 60) - (days * 24 * 60 + hours * 60));
    const seconds = Math.floor(secondsLeft - (days * 24 * 60 * 60 + (hours * 60 * 60) + (minutes * 60)));
    return { days, hours, minutes, seconds };
  }

  /**
   * Update all elements.
   */
  update() {
    this._elements.forEach(el => {
      this.updateElement(el);
    });
  }
}

const countdown = new Countdown();
export default countdown;
